import { Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import 'rxjs'
import { Compiler } from '@angular/core';

@Injectable()
export class ReportService {
    private _reportUrl= window.location.origin + '/ftportal/api/generateReport';
    private _getUrl= window.location.origin + '/ftportal/api/getReport';
    private _getDownload= window.location.origin + '/ftportal/api/getUploadedFile';
    private headers: HttpHeaders;
    private detailsBody: any;
    constructor(private _http: HttpClient, private _compiler: Compiler) {
    }
    getProducts(pageSize: string): any {
        this._compiler.clearCache();
        this.headers = new HttpHeaders()
                    .append('Cache-Control', 'no-cache')
                    .append('Pragma', 'no-cache');
        let params = new HttpParams();
        params = params.append('pageSize', pageSize)
                        .append('range', '10');
        return this._http.get(this._reportUrl, { params: params, headers: this.headers });
    }
    getReports(id: any, type: string): any {
        let params = new HttpParams();
        params = params.append('type', type)
                        .append('id', id);
        return this._http.get(this._getUrl, { params: params, headers: this.headers , responseType: 'blob'});
    }
      getDownloads(id: any): any {
        let params = new HttpParams();
        params = params.append('id', id);
        return this._http.get(this._getDownload, { params: params, headers: this.headers , responseType: 'blob'});
    }
}
